<template>
  <div class="per_data_form">
    <h5 class="text-info">{{ t("user_subscriptions.profiles.update_email") }}</h5>
    <loader-vue :visible="sending_request"/>
    <label for="email" v-if="!edit_mode">
      {{ t("user_subscriptions.profiles.current_email") }}:
    </label>
    <label id="new-email-label" for="email" v-if="edit_mode">
      {{ t("user_subscriptions.profiles.new_email") }}:
    </label>
    <input
      class="form-control mb-3"
      id="email"
      :disabled="!edit_mode"
      type="email"
      v-model="email_input"
      @input="clearErrors"
    />
    <button
      class="btn btn-primary btn-large"
      id="edit_email"
      v-if="!edit_mode"
      @click="toggleEditMode"
    >
      {{ t("components.forms.button.modify") }}
    </button>

    <form
      class="per_data_form"
      autocomplete="off"
      v-if="edit_mode"
      id="edit_container"
    >
      <label>{{ t("user_subscriptions.profiles.current_password") }}:</label>
      <forms-password-input-vue v-model="current_password" @keyup="clearErrors" />
    </form>

    <forms-messages-list-vue
      :messages= notifications
      :notification_message="true"
    />
    <forms-messages-list-vue
      :messages= errors
    />

    <div v-if="edit_mode" id="edit-buttons">
      <button
        class="btn btn-primary btn-large accept_button"
        id="accept"
        @click="validateForm"
        :disabled="sending_request"
      >
        {{ t("components.forms.button.accept") }}
      </button>
      <button class="btn btn-secondary btn-large" id="cancel" @click="cancel">
        {{ t("components.forms.button.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import mixins from "common/mixins";
import Validator from "common/Validator";
import constants from "common/constants";

export default {
  name: "user-subscription-profile-email-vue",
  components: {
    'forms-messages-list-vue': () => import(/* webpackChunkName: "[request]" */ "components/forms/MessagesList"),
    "forms-password-input-vue": () => import(/* webpackChunkName: "[request]" */ "components/forms/PasswordInput"),
    "loader-vue": () => import(/* webpackChunkName: "[request]" */ "components/Loader")
  },
  mixins: [mixins.requests, mixins.translate],
  props: ["email"],
  data() {
    return {
      email_input: this.email,
      edit_mode: false,
      errors: {},
      notifications: {},
      sending_request: false,
      current_password: "",
      password_min_length: constants.PASSWORD_MIN_LENGTH,
      password_max_length: constants.PASSWORD_MAX_LENGTH
    };
  },

  methods: {
    toggleEditMode() {
      this.edit_mode = !this.edit_mode;
      this.resetInputs();
    },

    cancel() {
      this.toggleEditMode();
      this.clearNotifications();
      this.clearErrors();
    },

    validateForm() {
      this.clearErrors();
      this.clearNotifications();

      let validator = new Validator([
        {
          fields: ["email actual", " email nuevo"],
          values: [this.email, this.email_input],
          validates: "changed",
        },
        {
          fields: "password",
          values: this.current_password,
          validates: "filled",
        },
        {
          fields: "email",
          values: this.email_input,
          validates: "email_format",
        },
      ]).do();

      if (!validator.success) {
        this.setErrors(validator.messages);
        return;
      }

      this.requestSave();
    },

    requestSave() {
      this.sending_request=true
      this.http_put({
        url: this.url_for_user_subscriptions_profile(),
        params: {
          field: "email",
          new_email: this.email_input,
          current_password: this.current_password,
        },
        success: (data) => {
          this.sending_request= false
          this.handleResponse(data.body);
        },
        error: () => {
          this.sending_request= false
        },
      });
    },

    handleResponse(request) {
      if (request.status == "password_invalid") {
        this.addError({
          password_invalid: this.t(
            "user_subscriptions.profiles.messages.password_invalid"
          ),
        });
        return;
      }

      this.notifySave();
      this.toggleEditMode();
    },

    notifySave() {
      this.addNotification({
        validation_sent: this.t(
          "user_subscriptions.profiles.messages.validation_sent",
          { email: this.email_input }
        ),
      });
    },

    clearErrors() {
      this.setErrors({});
    },

    clearNotifications() {
      this.setNotifications({});
    },

    setErrors(errors) {
      this.errors = errors;
    },

    setNotifications(notifications) {
      this.notifications = notifications;
    },

    addError(error) {
      let errors = Object.assign(error, this.errors);
      this.setErrors(errors);
    },

    addNotification(notification) {
      let notifications = Object.assign(notification, this.notifications);
      this.setNotifications(notifications);
    },
    resetInputs() {
      this.email_input= this.email
      this.current_password = "";
    },
  },
};
</script>

<style>
</style>
